import { useNavigate }           from "react-router-dom";
import   Style                   from "components/UI/main.module.scss";
import { GetSystemLabel }        from "Utilities/utils";

export const NotFound = () => {
    const navigate = useNavigate();
    return (
        <div style={{
            height: '100%',
            overflow: 'hidden',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            display: 'flex',
            position: 'relative'
        }}
        >
            <div className={[Style.star_wars_crawl].join(" ")}>
                <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}
                        style={{
                            height: "50%",
                            zIndex: 1,
                            position: "relative"
                        }} 
                >
                    <span className={[Style.fs_4, Style.mx_2, Style.text_body].join(" ")}>  
                        {GetSystemLabel("NotFound")}
                    </span>
                </div>
                <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}     
                        style={{
                            height: "50%",
                            zIndex: 1,
                            position: "relative"
                        }} 
                >
                    <div className={Style.mt_5}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.clickable,
                                            Style.vanilla_bg, 
                                            Style.rounded_3, 
                                            Style.border, 
                                            Style.shadow_sm, 
                                            Style.p_3,
                                            Style.pop_item_animation].join(" ")}
                            style={{ width: "100%" }}
                            onClick={() => {navigate("/");}}
                        >
                            <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                {GetSystemLabel("Return")}
                            </span>
                        </div>              
                    </div>                    
                </div>                            
            </div>
        </div>        
    );
};

const BestNotFound = () => {
    const navigate = useNavigate();
    return (
        <div style={{
            height: '100%',
            overflow: 'hidden',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            display: 'flex',
            position: 'relative',       
            backgroundColor: "#000" 
        }}
        >
            <div className={[Style.star_wars_crawl].join(" ")}>
                <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}
                        style={{
                            height: "50%",
                            zIndex: 1,
                            position: "relative"
                        }} 
                >
                    <span className={[Style.fs_4, Style.mx_2, Style.text_body].join(" ")}>  
                        {GetSystemLabel("NotFound")}
                    </span>
                </div>
                <div    className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}     
                        style={{
                            height: "50%",
                            zIndex: 1,
                            position: "relative"
                        }} 
                >
                    <div className={Style.mt_5}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.clickable,
                                            Style.vanilla_bg, 
                                            Style.rounded_3, 
                                            Style.border, 
                                            Style.shadow_sm, 
                                            Style.p_3,
                                            Style.pop_item_animation].join(" ")}
                            style={{ width: "100%" }}
                            onClick={() => {navigate("/");}}
                        >
                            <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                {GetSystemLabel("Return")}
                            </span>
                        </div>              
                    </div>                    
                </div>     
                <div  className={Style.space}> 
                            <svg
                                width="200"
                                height="200"
                                viewBox="0 0 22.00 32.00" 
                                xmlns="http://www.w3.org/2000/svg" 
                            >
                                <path d="M4.469 8.156v-2.25h2.25v2.25h-2.25zM15.688 5.906h2.219v2.25h-2.219v-2.25zM20.156 12.625v-4.469h2.25v8.969h-2.25v2.219h-2.25v2.25h2.25v2.25h2.25v2.219h-4.5v-2.219h-2.219v-2.25h-8.969v2.25h-2.25v2.219h-4.469v-2.219h2.25v-2.25h2.219v-2.25h-2.219v-2.219h-2.25v-8.969h2.25v4.469h2.219v-2.219h2.25v-2.25h2.25v2.25h4.469v-2.25h2.25v2.25h2.219v2.219h2.25zM8.969 14.875v-2.25h-2.25v2.25h2.25zM15.688 14.875v-2.25h-2.25v2.25h2.25z"/>
                            </svg>
                </div>      
                <div className={Style.warp}>
                    {Array.from({ length: 80 }).map((_, i) => {
                        const angle = Math.random() * 2 * Math.PI;
                        const distance = 800;

                        const x = Math.cos(angle) * distance + "px";
                        const y = Math.sin(angle) * distance + "px";

                        return (
                            <span
                                key={i}
                                className={Style.star}
                                style={{
                                    "--x": x,
                                    "--y": y,
                                    animationDelay: `${Math.random() * 1.5}s`
                            }}
                            />
                        );
                    })}
                </div>                             
            </div>
        </div>        
    );
};